export default __webpack_public_path__ + "static/media/ga_logo.79a41c58.png";